import { render, staticRenderFns } from "./LifeStageInfo.vue?vue&type=template&id=dc5854da&scoped=true&"
import script from "./LifeStageInfo.vue?vue&type=script&lang=js&"
export * from "./LifeStageInfo.vue?vue&type=script&lang=js&"
import style0 from "./LifeStageInfo.vue?vue&type=style&index=0&id=dc5854da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5854da",
  null
  
)

export default component.exports